<template>
  <router-view/>
</template>

<script>
export default {
  name: 'AuthIndex'
}
</script>